import { setHistoryFilesById, setHistoryFilesTimeout } from 'app/store/dcra-inspections/inspections';
import { WebsocketMessage } from 'app/types';
import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';

export interface FileGeneratedProps {
  message: WebsocketMessage;
}

/**
 * For Permit Inspections History
 * @param props
 * @returns
 */
export default function InspectionFiles(props: FileGeneratedProps) {
  const { message } = props;

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (message.model.error) {
      dispatch(setHistoryFilesTimeout(message.model.accela_inspection_id));
    } else {
      dispatch(
        setHistoryFilesById(
          message.model.accela_inspection_id,
          message.model.results
        )
      );
    }
  }, [message.uuid]);

  return null;
}
